jQuery(document).ready(function($) { 

	  /*  ***************************
    SCROLL FIXED MENU 
  ******************************** */

  var header = $('#masthead');
  var l_window_full = $(window).width();
  let top_scroll = 0;
  if(l_window_full < 1025){
    top_scroll = 80;
  }

   if(!$('body').hasClass('home')){
     $(window).scroll(function () {
       // if(l_window > 1023){
          action_on_scroll();
       // }
      });
   }



    function action_on_scroll(){
      l_window_full = parseInt($(window).width());
       if ($(window).scrollTop() > 50){
          header.addClass("Masthead--sticky");
          $("body").addClass('header--sticky');
        }else{
           header.removeClass("Masthead--sticky");
           $("body").removeClass('header--sticky');
        }
   }



	 /* Open / Close MENU */
	 $(".menu-toggle").click(function(e){
      if($(this).attr('aria-expanded') == 'true'){
        $('body').addClass('open_menu');
      }else{
         $('body').removeClass('open_menu');
      }
   });  


	 // /**************************************************************************************/
		// /*********************** GALERIE D'IMAGE // SERVICES ITEM  *********************************/
	// /**************************************************************************************/

   $( ".ServiceItem" ).each(function( index ) {

    var id_service = $(this).attr('id');
    var delay_swiper = parseInt(5000+600*index);
   
    var swiper_container_Tophome = new Swiper('#swiper-'+id_service, {

    // If we need pagination
      spaceBetween: 60, // try '5%' if you want
      slidesPerView: 1,
      loop: true,
      speed:1500,
      centeredSlides:false,
       autoplay: {
          delay: delay_swiper,
          disableOnInteraction: true,
      },

     pagination: {
           el: '.swiper-bullet-pagination',
           clickable: true
      },

      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },

  });

  });

   


   


    // /**************************************************************************************/
        // /*********************** SLIDER DE LOGO DANS A PROPOS  *********************************/
    // /**************************************************************************************/


     var swiper_container_LogoSlider = new Swiper('.swiper-container-LogoSlider', {

      // If we need pagination
        spaceBetween: 20, // try '5%' if you want
        slidesPerView: 3,
        loop: true,
        centeredSlides:false,
         autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        navigation: {
          nextEl: '.swiper-button-nav-logos .swiper-button-next',
          prevEl: '.swiper-button-nav-logos .swiper-button-prev',
        },
        breakpoints: {
          1200: { // a partir de 12001
            slidesPerView: 5,
            centeredSlides:false,
            spaceBetween: 60,
          },
          768: { // a partir de 769
            slidesPerView: 4,
            centeredSlides:false,
            spaceBetween: 40,
          }
        }

    });


         // /**************************************************************************************/
        // /*********************** SLIDER PROJET / FLEXIBLE ET FIN PROJET  *********************************/
    // /**************************************************************************************/


     var swiper_container_MoreProject = new Swiper('.swiper-container-MoreProject', {

      // If we need pagination
        spaceBetween: 20, // try '5%' if you want
        slidesPerView: 1.5,
        loop: true,
        centeredSlides:false,
         autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        breakpoints: {
          768: { // a partir de 769
            slidesPerView: 3,
            centeredSlides:false,
            spaceBetween: 20,
          }
        }

    });


     // /**************************************************************************************/
        // /*********************** SLIDER DE POST / FLEXIBLE ET FIN POST  *********************************/
    // /**************************************************************************************/


     var swiper_container_MorePost = new Swiper('.swiper-container-MorePost', {

      // If we need pagination
        spaceBetween: 20, // try '5%' if you want
        slidesPerView: 1.5,
        loop: true,
        centeredSlides:false,
         autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        breakpoints: {
          1400: { // a partir de 769
            slidesPerView: 3,
            centeredSlides:false,
            spaceBetween: 83,
          },
          768: { // a partir de 769
            slidesPerView: 3,
            centeredSlides:false,
            spaceBetween: 20,
          }
        }

    });



     
  
   ////////////////
    //// GLOBAL accordion // Flexible, exemple : single fontaine
   ///////////////
   $('.accordion-section-content').hide(); //   $('.accordion-section-content:not(.first)').hide();
  // $('.acc-item.first').addClass('active'); // FIRST
    //$('#content_s_1').parent().find('h2 a').addClass('active');

   //$('.accordion-section-content').hide();
    // accordion SECTION 
    function close_accordion_section() {
        $('.accordion-page .accordion-section-title').removeClass('active');
        $('.accordion-page .accordion-section-content').slideUp(300).removeClass('open');
    }

    $('.accordion-section-title').click(function(e) {
        // Grab current anchor value
        var currentAttrValue = $(this).attr('aria-controls');
      
        var parentActiveAcc = $(this).parent().parent().parent().attr('data-accordion-id');

         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).slideUp(300);
         $(parentActiveAcc + ' .acc-item.active .accordion-section-title:not([aria-controls="'+currentAttrValue+'"])').attr('aria-expanded', 'false');
         $(parentActiveAcc + ' .acc-item.active .acc-item-Content').not('#'+currentAttrValue).parent().removeClass('active'); 

        if($(this).parent().parent().hasClass('active')) {
          
           // close_accordion_section();
            $(this).attr('aria-expanded', 'false');
            $('.accordion-page ' + '#'+currentAttrValue).slideUp(300).removeClass('open');
            $(this).parent().parent().removeClass('active');

        }else {
          //  close_accordion_section();
 
            // Add active class to section title
            $(this).parent().parent().addClass('active');
            $(this).attr('aria-expanded', 'true');
            // Open up the hidden content panel
            $('.accordion-page ' + '#'+currentAttrValue).slideDown(300).addClass('open');
        }
 
        e.preventDefault();
    });
    // FIN accordion //
    ////////////////////





  /**************************************************************************************/
/*********************** ALL PROJECT ISOTOPE ALL PROJECT FILTER *********************************/
  /**************************************************************************************/
    
    //    /* Masonry Project archive */  
      var $container_all_ref = $('.archive-container-project');
      var grid_isotope;
      var class_filter_init = '*';
     
      if(object_var.filter_type != '*') class_filter_init = '.'+object_var.filter_type;
     $container_all_ref.imagesLoaded(function () {
      $grid_isotope = $container_all_ref.isotope({
              itemSelector: '.item-resume-project',
              percentPosition: true,
              filter:class_filter_init,
              layoutMode: 'fitRows',
            //  sortBy : 'random',
               fitRows: {
              columnWidth: '.item-img-sizer',
              gutter: '.item-img-gutter',
          }
      });
      $grid_isotope.on( 'arrangeComplete', onEndArrange );
     });


     $('.button-group').on( 'click', 'button', function() {
      var filterValue = $(this).attr('data-filter');
      $('.button-group button').removeClass('active');
      $('.button-group button[data-filter="'+filterValue+'"]').addClass('active');
      $grid_isotope.isotope({ filter: filterValue });
      if($(this).parent().parent().hasClass('sub-menu')){
       $('#menu-toggle').trigger('click');

         if($('.menu-toggle').attr('aria-expanded') == 'true'){
            $('body').addClass('open_menu');
          }else{
             $('body').removeClass('open_menu');
          }
      }
    });

     function onEndArrange(){  
      var $LogoGallery = new Swiper('.js-swiper-LogoGallery', {
        
          slidesPerView: 1,
    
          loop: true,
          speed: 1000,
          allowTouchMove: false,
          slideToClickedSlide: false,
          effect: 'fade',
          fadeEffect: {
            crossFade: true
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
         
        //watchSlidesProgress: true,
      });
     }




     /**************************************************************************************/
     /******************** MASONRY INDEX - ARTICLE *****************************/
     /**************************************************************************************/



    //    /* Masonry Project archive */  
      var $container_all_posts = $('.archive-container-post');
      var $grid_isotope_posts;
   //   var class_filter_init = '*';
     
      if(object_var.filter_type != '*') class_filter_init = '.'+object_var.filter_type;
     $container_all_posts.imagesLoaded(function () {
      $grid_isotope_posts = $container_all_posts.isotope({
              itemSelector: '.resume-post-masonry',
              percentPosition: true,
            //  filter:class_filter_init,
              layoutMode: 'masonry',
            //  sortBy : 'random',
               masonry: {
              columnWidth: '.item-img-sizer',
              gutter: '.item-img-gutter',
          }
      });
      $grid_isotope_posts.on( 'arrangeComplete', onEndArrange );
     });



         // FORM CONTACT LABEL ///

      $( ".wpcf7-form label.to_move" ).click(function() {
          $( this ).parent().addClass('focus');
      });

      $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
          $( this ).parent().parent().addClass('focus');
      });

       $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
          if($(this).val() != '') $( this ).parent().parent().addClass('focus');
      });




      // Exemple poussée 
      // https://codepen.io/GreenSock/pen/XWmEoNg




      function update_all_tween(self){
        if( self.progress > progress_second){
          $('body').addClass('ChangeSlogan');
        }else{
          $('body').removeClass('ChangeSlogan');
        }
      }

      // // helper function that lets us define a section in a timeline that spans between two times (start/end) and lets us add onEnter/onLeave/onEnterBack/onLeaveBack callbacks
    function addSectionCallbacks(timeline, {start, end, param, onEnter, onLeave, onEnterBack, onLeaveBack}) {
      let trackDirection = animation => { // just adds a "direction" property to the animation that tracks the moment-by-moment playback direction (1 = forward, -1 = backward)
        let onUpdate = animation.eventCallback("onUpdate"), // in case it already has an onUpdate
            prevTime = animation.time();
        animation.direction = animation.reversed() ? -1 : 1;
        animation.eventCallback("onUpdate", () => {
          let time = animation.time();
          if (prevTime !== time) {
            animation.direction = time < prevTime ? -1 : 1;
            prevTime = time;
          }
          onUpdate && onUpdate.call(animation);
        });
      },
       empty = v => v; // in case one of the callbacks isn't defined
      timeline.direction || trackDirection(timeline); // make sure direction tracking is enabled on the timeline
      start >= 0 && timeline.add(() => ((timeline.direction < 0 ? onLeaveBack : onEnter) || empty)(param), start);
      end <= timeline.duration() && timeline.add(() => ((timeline.direction < 0 ? onEnterBack : onLeave) || empty)(param), end);
    }


      if($('body').hasClass('home') &&  l_window_full > 1024){


      var l_window = parseInt(document.querySelector("body").offsetWidth - 148);
      var calculate_w = 0;
      var child_c = $('.container').children();
      var progress_second = 0;
     //const snap_array = [0];

       $( child_c).each(function( index ) {

         calculate_w += $( this ).width();

          if(index == 1){
            progress_second = calculate_w - $( this ).width();
         }
        
      });

       progress_second = ((502 + 58) / calculate_w);

    
      //  $(child_c).each(function( index ) {
      //    snap_array.push(parseInt($( this ).position().left + $( this ).width() - 148) / calculate_w);
      //    console.log("SnapTo"+ parseInt($( this ).position().left + $( this ).width() - 148) / calculate_w);
      // });

       //snap_array.push = [1];

       var container_to_scrool_h = document.querySelector(".container");
       var w_container_to_scrool_h = calculate_w;
       console.log('Width container '+w_container_to_scrool_h);
       
        console.log('Width window '+ l_window);

        let duration = 10;
        let sections = gsap.utils.toArray(".panel");
        sectionIncrement = duration / (sections.length - 1),
        tl = gsap.to('.container',{
          x: - parseInt(w_container_to_scrool_h - l_window * 1),
          scrollTrigger: {
            trigger: ".container",
            pin: true,
            scrub: 1,
            // snap: 1 / (sections.length - 1),
            //start: "top top",
            end: "+=" + parseInt(document.querySelector(".container").offsetWidth),
            onUpdate: (self) => update_all_tween(self)
          }
        }); 

      

        // tl.to(sections, {
        //    x: - parseInt(w_container_to_scrool_h - l_window * 1),
        //   duration: duration,
        //   ease: "none"
        // });



        
       // let index = 1;
       //  let tween = gsap.from('.panel_s2_des_graph', {
       //     y:100,
       //     duration: 1,
       //  });

       //  addSectionCallbacks(tl, {
       //      start: sectionIncrement * (index - 0.99),
       //      end: sectionIncrement * (index + 0.99),
       //      onEnter: () => tween.play(),
       //      onLeave: () => tween.reverse(),
       //      onEnterBack: () => tween.play(),
       //      onLeaveBack: () => tween.reverse()
       //    });
       //    index || tween.progress(1); // the first tween should be at its end (already faded/scaled in)
       //  // });


   
        // sections.forEach((section, index) => {
        //   let tween = gsap.from(section, {
        //     opacity: 1, 
        //    // scale: 0.8, 
        //     translateY:-100,
        //     duration: 1, 
        //  //   force3D: true, 
        //     paused: true
        //   });

        //   addSectionCallbacks(tl, {
        //     start: sectionIncrement * (index - 0.99),
        //     end: sectionIncrement * (index + 0.99),
        //     onEnter: () => tween.play(),
        //     onLeave: () => tween.reverse(),
        //     onEnterBack: () => tween.play(),
        //     onLeaveBack: () => tween.reverse()
        //   });
        //   index || tween.progress(1); // the first tween should be at its end (already faded/scaled in)
        // });



    }




    // /**************************************************************************************/
    // /*********************** SWIPER GALERIE ACCUEIL  *********************************/
  // /**************************************************************************************/


     var swiper_container_GalerieHome = new Swiper('.swiper-container-GalerieHome', {

    // If we need pagination
      spaceBetween: 60, // try '5%' if you want
      slidesPerView: 1,
      loop: true,
      centeredSlides:false,
       autoplay: {
          delay: 3000,
          disableOnInteraction: true,
      },

     // pagination: {
     //       el: '.swiper-bullet-pagination',
     //       clickable: true
     //  },

      // navigation: {
      //   nextEl: '.swiper-button-next',
      //   prevEl: '.swiper-button-prev',
      // },

  });



     $(document).on("click", ".link_to_scroll", function(e) {
     var item_split = $(this).attr("href");
     var offsetTop = $(item_split).offset().top-top_scroll;

      $('html, body').stop().animate({ 
          scrollTop: offsetTop
      }, 600);
      e.preventDefault();
  });


     $('.js-open-info-popup').featherlight({
          type : 'html',
          persist:'shared',
       //   contentFilters: ["html"],
          closeIcon: '<i class="icon-close"></i>', 
          afterContent : function(event){

          } // fin aftercontent

    }); // FIN FEATHERLIGTH



}); // fin ready menu


